// Shared styling for prominent segmented sub-tabs (navy active pill).
const COLS = { 1: "grid-cols-1", 2: "grid-cols-2", 3: "grid-cols-3", 4: "grid-cols-4" };

export const tabsListClass = (cols = 2) =>
  `grid ${COLS[cols] || "grid-cols-2"} w-full h-auto p-1.5 rounded-2xl bg-[var(--brand-navy)]/8 mb-5 gap-1.5`;

export const tabTriggerClass =
  "rounded-xl py-2.5 text-xs sm:text-sm font-semibold flex items-center justify-center gap-1.5 " +
  "text-[var(--brand-navy)]/70 transition-all data-[state=active]:bg-[var(--brand-navy)] " +
  "data-[state=active]:text-white data-[state=active]:shadow-md";
